import createIcon from '../../icons/createIcon';

const IconClose = createIcon('IconClose', '0 0 64 64', [
    [
        'path',
        {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M18.0003 15.1719L19.4145 16.5861L32.0005 29.1721L44.5865 16.5861L46.0007 15.1719L48.8291 18.0003L47.4149 19.4145L34.8289 32.0005L47.4145 44.5861L48.8287 46.0003L46.0003 48.8287L44.5861 47.4145L32.0005 34.8289L19.4149 47.4145L18.0007 48.8287L15.1723 46.0003L16.5865 44.5861L29.1721 32.0005L16.5861 19.4145L15.1719 18.0003L18.0003 15.1719Z',
            fill: '#191B21',
            key: 'b43d4b'
        },
        []
    ]
]);

export { IconClose };
